import i18n from '@/locales'

export const statusMap = {
  completed: i18n.t('common_441'),
  active: i18n.t('common_440'),
  externally_terminated: i18n.t('common_442'),
}

export const alertResourceTypeMap = {
  host: {
    sidePageName: 'HostSidePage',
    resource: 'hosts',
  },
  guest: {
    sidePageName: 'VmInstanceSidePage',
    resource: 'servers',
  },
  cloudaccount: {
    sidePageName: 'CloudaccountSidePage',
    resource: 'cloudaccounts',
  },
  rds: {
    sidePageName: 'RDSSidePage',
    resource: 'dbinstances',
  },
  redis: {
    sidePageName: 'RedisSidePage',
    resource: 'elasticcaches',
  },
}
